ACC.suggestedproducts = {
  bindAll: function() {
    if ($(window).width() > 600) {
      ACC.suggestedproducts.cardsCarousel();
    } else {
      var cardWidth = $('.ph-suggested-products__jcarousel').innerWidth() / 2.25;

      $('.ph-suggested-products').find('li').css('width', cardWidth + 'px');
    }

    ACC.suggestedproducts.activePage();
  },

  cardsCarousel: function() {
    var $jcarousel = $('.ph-suggested-products__jcarousel');

    $jcarousel.on('jcarousel:reload jcarousel:create', function() {
      var $carousel = $(this),
          width = $carousel.innerWidth();

      if (width >= 725) {
        width = width / 4;
      } else if (width < 725) {
        width = width / 3;
      }

      $carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');
    }).jcarousel({
      wrap: null
    }).jcarouselSwipe({
      perSwipe: 1
    });

    $('.ph-suggested-products__prevarrow').on('jcarouselcontrol:inactive', function() {
      $(this).addClass('ph-inactive');
    }).on('jcarouselcontrol:active', function() {
      $(this).removeClass('ph-inactive');
    }).jcarouselControl({
      target: '-=1'
    });

    $('.ph-suggested-products__nextarrow').on('jcarouselcontrol:inactive', function() {
      $(this).addClass('ph-inactive');
    }).on('jcarouselcontrol:active', function() {
      $(this).removeClass('ph-inactive');
    }).jcarouselControl({
      target: '+=1'
    });

    $jcarousel.on('jcarousel:animateend', function() {
      ACC.suggestedproducts.activePage();
    });
  },

  activePage: function() {
    var pageNumber = 1;
    var navigationList = $('.ph-jcarousel-pagination').find('a');
    var completeUrl = window.location.href;

    if (completeUrl.indexOf('#') !== -1) {
      pageNumber = completeUrl.split('#').splice(1, 1).join();
    }

    navigationList.each(function() {
      $(this).find('span').removeClass('ph-active-page');

      if (('#' + pageNumber) === $(this).attr('href')) {
        $(this).find('span').addClass('ph-active-page');
      }
    });
  }
};

$(document).ready(function() {
  if ($(document).find('.ph-suggested-products').length > 0) {
    ACC.suggestedproducts.bindAll();
  }
});

$(window).resize(function() {
  if ($('body').hasClass('ph-page-productDetails')) {
    ACC.suggestedproducts.bindAll();
  }
});
